module.exports = __webpack_public_path__ + "static/media/Strain.7a6fd0da.svg";